<h1 matDialogTitle>{{ data.title }}</h1>
<div mat-dialog-content>
  <mat-card class="p-0">
    <form [formGroup]="produtoForm">
      <div class="form-container" fxLayout="column" fxLayoutGap="16px">
        <!-- Informações de Movimentação -->
        <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="8px">
          <ng-container *ngIf="detailsMovto && detailsMovto?.numero_lcto > 0; else noMovto">
            <mat-chip-list>
              <mat-chip color="primary" selected>TOTAL DE LCTOS:</mat-chip>
              <mat-chip color="accent">{{ detailsMovto.numero_lcto }}</mat-chip>
              <mat-chip color="primary">Data do Primeiro Lcto:</mat-chip>
              <mat-chip color="accent">{{ detailsMovto.data_primeiro_lcto | date: "dd/MM/yyyy" }}</mat-chip>
              <mat-chip color="primary">Data do Último Lcto:</mat-chip>
              <mat-chip color="accent">{{ detailsMovto.data_ultimo_lcto | date: "dd/MM/yyyy" }}</mat-chip>
            </mat-chip-list>
          </ng-container>
          <ng-template #noMovto>
            <mat-chip-list>
              <mat-chip color="primary">Não há lançamentos registrados</mat-chip>
            </mat-chip-list>
          </ng-template>
        </div>

        <!-- Filtros -->
        <div fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutGap="16px">
          <div fxFlex="20" fxFlex.lt-md="100" fxFlex.sm="33">
            <mat-form-field class="full-width">
              <mat-label>Data Inicial</mat-label>
              <input
                matInput
                type="date"
                [(ngModel)]="dataInicial"
                (change)="reloadPageMovto()"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
          </div>
          <div fxFlex="20" fxFlex.lt-md="100" fxFlex.sm="33">
            <mat-form-field class="full-width">
              <mat-label>Data Final</mat-label>
              <input
                matInput
                type="date"
                [(ngModel)]="dataFinal"
                (change)="reloadPageMovto()"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
          </div>
          <div fxFlex="10" fxFlex.lt-md="100" fxFlex.sm="33" fxLayoutAlign="start center">
            <button mat-raised-button color="primary" (click)="reloadPageMovto()">
              <mat-icon>refresh</mat-icon>
              <span fxHide.lt-md>Atualizar</span>
            </button>
          </div>
        </div>

        <!-- Tabela -->
        <div fxFlex="100">
          <ngx-datatable
            class="material ml-0 mr-0"
            [rows]="movtos"
            [headerHeight]="50"
            [footerHeight]="50"
            [scrollbarH]="true"
            [messages]="{ emptyMessage: 'Nenhuma movimentação encontrada p/ o período' }"
            [limit]="pageSize"
            [rowHeight]="50"
          >
            <ngx-datatable-column name="#" [width]="25">
              <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                <strong>{{ rowIndex + 1 }}</strong>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Opções" [flexGrow]="1" [width]="100">
              <ng-template let-row="row" ngx-datatable-cell-template>
                <button
                  mat-icon-button
                  color="primary"
                  class="mr-1"
                  (click)="$event.preventDefault(); openLcto(row?.lcto.controle)"
                >
                  <mat-icon>edit</mat-icon>
                </button>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Data" [flexGrow]="1" [width]="120">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.dataMovto | date: "dd/MM/yyyy" }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Controle" [flexGrow]="1" [width]="120">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.lcto.controle.toString().padStart(10, "0") }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Nat" [flexGrow]="1" [width]="90">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.natureza === "S" ? "Saída" : "Entrada" }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Docto" [flexGrow]="1" [width]="120">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{
                  (row?.lcto?.serie?.codigo === null ? "" : row.lcto.serie.codigo + "-") +
                    row?.lcto?.numeroDocto?.toString().padStart(9, "0")
                }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Cadastro" [flexGrow]="1" [width]="250">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.cadastro.codigo + "-" + row?.cadastro.razaoSocial }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Transação" [flexGrow]="1" [width]="250">
              <ng-template let-row="row" ngx-datatable-cell-template>
                {{ row?.fatTransacao.codigo + "-" + row?.fatTransacao.descricao }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Total" [flexGrow]="1" [width]="120">
              <ng-template ngx-datatable-header-template let-column="column">
                <div style="text-align: right">
                  <span title="Total do Lançamento">Total</span>
                </div>
              </ng-template>
              <ng-template let-row="row" ngx-datatable-cell-template>
                <div style="text-align: right">
                  {{ row?.lcto.valortotalDocto | currency: "BRL" }}
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-footer>
              <ng-template ngx-datatable-footer-template>
                <mat-paginator
                  #paginator
                  [length]="length"
                  [showFirstLastButtons]="true"
                  [pageSize]="pageSize"
                  [pageSizeOptions]="pageSizeOptions"
                  (page)="pageEvent = setPageSizeOptions($event)"
                ></mat-paginator>
              </ng-template>
            </ngx-datatable-footer>
          </ngx-datatable>
        </div>
      </div>
    </form>
  </mat-card>
</div>
<mat-dialog-actions>
  <div fxFlex="100" class="action-buttons">
    <span fxFlex></span>
    <button mat-button color="warn" type="button" (click)="close()">
      <mat-icon>close</mat-icon> {{ "CLOSE" | translate }}
    </button>
  </div>
</mat-dialog-actions>